<script>
import NavigationHeader from '../NavigationHeader.vue';
import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
import ButtonNormal from '../buttons/ButtonNormal.vue';
import Modal from '../shared/Modal.vue';
import FileUploader from '../shared/file-uploader/FileUploader.vue';

import axios from 'axios';
import UserService from '@/services/UserService';
import GroupService from '@/services/GroupService';
import PhonenumberService from '@/services/PhonenumberService';
import FaxUserService from '@/services/FaxUserService';
import SupportUserService from '@/services/SupportUserService';
import VoicemailboxService from '@/services/VoicemailboxService';
import SorterService from '@/services/SorterService';
import NumberPicker from '../shared/NumberPicker.vue';
import { SERVICE_ID, INTERNAL_PHONENUMBERS, URLS, HOTLINE } from '@/services/Constants';
import {required} from 'vuelidate/lib/validators';
import utils from '@/services/xml-rpc/utils';
import { mapActions } from 'vuex';

export default {
    name: 'HotlineEdit',
    components: {
        NavigationHeader,
        ButtonIconLeft,
        ButtonNormal,
        Modal,
        NumberPicker,
        FileUploader
    },
    data() {
        return {
            id: this.$route.query.mode,
            editMode: false,
            isModalForDeleteVisible: false,
            isModalForUpdateVisible: false,
            isSubmitted: false,
            allExternalPhonenumbers: [],
            allInternalPhonenumbers: [],
            internalPhonenumberId: null,
            pickedPhonenumber: null,
            title: 'Neue Hotline mit Sprachmenü erstellen',
            saveButtonTitle: 'Hotline erstellen',
            fileUploaderConfig: {
                title: '',
                intro: `Konfiguriere ein Sprachdialogsystem für eingehende Anrufe. Lade Eure Ansage im WAV Format hoch
                 und lege anschließend die Tastenzuordnung fest. „Drücken Sie die 1,
                 wenn Sie mit dem Vertrieb sprechen möchten. Drücken Sie die 2, wenn Sie mit dem Support verbunden werden möchten...“`,
                file: {
                    type: '.wav',
                    selected: false
                },
                info: {
                    preFileText: 'Sprachmenü:',
                    fileName: 'Keine Sounddatei hochgeladen',
                    selectedFile: ''
                }
            },
            ivrData: {
                speachSystemKeys: [],
                wavFile: null
            },
            hotline: {}
        };
    },
    created() {
        this.editMode = this.id !== undefined;
        const self = this;
        axios
            .all([PhonenumberService.getAllPhonenumbers()])
            .then(
                axios.spread((phoneNumbers) => {
                    if (phoneNumbers.status === 200) {
                        self.getAndSortAllAvailablePhonenumbers(
                            phoneNumbers.data
                        );
                        if (self.editMode) {
                            self.getHotlineIVR().then( response => {
                                self.hotline = response;
                                if (response.GUI_SPRACHMENUE !== '') {
                                    self.fileUploaderConfig.info.fileName = 'Ansage hinterlegt';
                                }
                                self.ivrData.speachSystemKeys = self.convertIvrKeysToSpeachSystemKeys(response.GUI_TASTENZUORDNUNG);
                                self.fillCurrentExternalPhonenumberInForm();
                            });
                            self.title = 'Hotline mit Sprachmenü bearbeiten';
                            self.saveButtonTitle = 'Änderungen speichern';
                        } else {
                            self.setDefaultPhonenumber();
                        }
                    }
                })
            );
    },
    computed: {
        usedSpeachSystemKeys() {
            return this.ivrData.speachSystemKeys.map(({ button }) => button);
        },
        getParamsForIvr() {
            const params = {
                GUI_TASTENZUORDNUNG: this.convertSpeachSystemKeysForIvr(this.ivrData.speachSystemKeys),
                GUI_RUFNUMMER: this.pickedPhonenumber.phoneNumberComplete
            };
            if (this.ivrData.wavFile) {
                params.GUI_SPRACHMENUE =  this.ivrData.wavFile;
            }
            return params;
        }
    },
    methods: {
        ...mapActions(['createHotlineIVR', 'getHotlineIVR', 'updateHotlineIVR', 'deleteHotlineIVR']),
        closeModalForDelete() {
            this.isModalForDeleteVisible = false;
        },
        confirmModalForDelete() {
            this.isModalForDeleteVisible = false;
            this.deleteHotline();
        },
        closeModalForUpdate() {
            this.isModalForUpdateVisible = false;
        },
        confirmModalForUpdate() {
            this.isModalForUpdateVisible = false;
            if (this.editMode) {
                this.updateHotline();
            } else {
                this.createNewHotline();
            }
        },
        setDefaultPhonenumber() {
            for (const entry of this.allExternalPhonenumbers) {
                if (this.pickedPhonenumber === null && entry.available) {
                    this.pickedPhonenumber = entry;
                    break;
                }
            }
        },
        getAndSortAllAvailablePhonenumbers(responsePhonenumbers) {
            const {
                external,
                internal,
                internalPhoneNumberId
            } = PhonenumberService.splitAndSortNumbersForGroups(
                responsePhonenumbers,
                this.internalPhonenumberId
            );
            this.allExternalPhonenumbers = external;
            this.allInternalPhonenumbers = internal;
            if (!this.editMode) {
                this.internalPhonenumberId = internalPhoneNumberId;
            }
        },
        fillCurrentExternalPhonenumberInForm() {
            for (const phonenumber of this.allExternalPhonenumbers) {
                if (String(phonenumber.phoneNumberComplete) === this.hotline.GUI_RUFNUMMER) {
                    phonenumber.available = true;
                    this.pickedPhonenumber = phonenumber;
                    break;
                }
            }
        },
        createNewHotline() {
            this.createHotlineIVR(this.getParamsForIvr).then( response => {
                if (response) {
                    this.showToastSuccessAndNavigate('Hotline erfolgreich hinzugefügt');
                } else {
                    this.showToastError('Hotline konnte nicht erstellt werden');
                }
            });
        },
        updateHotline() {
            this.updateHotlineIVR(this.getParamsForIvr).then( response => {
                if (response) {
                    this.showToastSuccessAndNavigate('Änderungen gespeichert');
                } else {
                    this.showToastError('Hotline konnte nicht geändert werden');
                }
            });
        },
        saveHotline() {
            this.isSubmitted = true;
            if (this.editMode) {
                this.isModalForUpdateVisible = true;
            } else {
                this.confirmModalForUpdate();
            }
        },
        deleteHotline() {
            this.deleteHotlineIVR().then( response => {
                if (response) {
                    this.showToastSuccessAndNavigate('Hotline wurde gelöscht');
                } else {
                    this.showToastError('Hotline konnte nicht gelöscht werden');
                }
            });
        },
        openDeleteModal() {
            this.isModalForDeleteVisible = true;
        },
        uploadFile(event) {
            const file = event.target.files[0];
            if (file) {
                this.fileUploaderConfig.file.selected = true;
                this.fileUploaderConfig.info.selectedFile = file.name;
                utils.getBase64(file).then(
                    data => {
                        this.ivrData.wavFile = data;
                    }
                );
            }
        },
        showToastSuccessAndNavigate(message) {
            message ? this.$toasted.global.starface_success({message: `${message}`, icon: 'GROUP'}) : '';
            this.$router.push('/groups');
        },
        showToastError(message) {
            message ? this.$toasted.global.starface_error({message: `${message}`, icon: 'GROUP'}) : '';
        },
        deleteSpeachSystemKey(index) {
            this.ivrData.speachSystemKeys.splice(index, 1);
        },
        addSpeachSystemKey() {
            if (this.ivrData.speachSystemKeys.length !== 9) {
                const remainingFirsNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9].find(this.getFirstAvailableNumber);
                this.ivrData.speachSystemKeys.push({button: remainingFirsNumber});
            }
        },
        getFirstAvailableNumber(element) {
            return !this.usedSpeachSystemKeys.includes(element);
        },
        checkIfSpeachSystemKeysContainsNumber(element) {
            return this.usedSpeachSystemKeys.includes(element);
        },
        convertSpeachSystemKeysForIvr(keys) {
            const obj = {};
            keys.forEach( key => {
                obj[key.button] = key.number;
            });
            return obj;
        },
        convertIvrKeysToSpeachSystemKeys(keys) {
            const arr = [];
            if (keys) {
                for (const [key, value] of Object.entries(keys)) {
                    const obj = {
                            button: +key,
                            number: value
                        };
                    arr.push(obj);
                }
            }
            return arr;
        }
    }
};
</script>

<template>
    <div class="container">
        <div id="group-edit">
            <NavigationHeader route="/groups" navigationText="zurück zur Übersicht" :title="title"/>
            <div class="wrapper">
                <div class="description">
                    Wähle eine Rufnummer für Eure Hotline aus und richte Euer persönliches Sprachmenü ein.
                </div>
                <form class="form">
                    <div class="phone-numbers">
                        <div class="title">Rufnummer der Hotline</div>
                        <NumberPicker v-if="pickedPhonenumber" :numbers="allExternalPhonenumbers" :max-height="'200px'" :columns="4" :defaultValue="pickedPhonenumber" v-model="pickedPhonenumber"/>
                    </div>
                </form>
                <div class="speach-system">
                    <div class="speach-system-upload">
                        <div class="section-title">Sprachdialogsystem</div>
                        <FileUploader :config="fileUploaderConfig" @uploadFile="uploadFile"/>
                    </div>
                    <div class="speach-system-keys">
                        <div class="speach-system-keys">
                            <div class="section-title">Tastenbelegung festlegen</div>
                            <div class="section-description">Lege hier die Tastenbelegung fest. Der Anrufer wird durch das Drücken der entsprechenden Ziffer an die jeweilig hinterlegte Zielrufnummer weitergeleitet. Bitte beachte, Rufnummern ohne Leerzeichen anzugeben. <a style="color:#F59B00;text-decoration: underline;" href="https://knowledge.starface.de/display/starup/Hotline+mit+Sprachmenue" target="_blank">Mehr Info</a></div>
                            <table>
                                <tr>
                                    <th>Taste/Ziffer</th>
                                    <th>Zielrufnummer</th>
                                    <th></th>
                                </tr>
                                <tr v-for="(entry, index) in ivrData.speachSystemKeys" :key="index">
                                    <td>
                                    <label class="custom-select">
                                        <select id="styledSelect1" name="options" v-model="entry.button">
                                            <option disabled="disabled">Taste auswählen</option>
                                            <option v-for="(num, ind) in 9" :key="ind" :disabled="checkIfSpeachSystemKeysContainsNumber(num) && num !== entry.button ? true : false" :value="num"> {{num}}</option>
                                        </select>
                                    </label>
                                    </td>
                                    <td><input class="table-number-input" v-model="entry.number" placeholder="nummer"></td>
                                    <td><ButtonIconLeft class="btn-edit" @onClick="deleteSpeachSystemKey(index)" buttonTitle="löschen" src="delete" cssClass="btn btn-tertiary"/></td>
                                </tr>
                            </table>
                            <div class="table-footer">
                                <ButtonIconLeft class="btn-add" @onClick="addSpeachSystemKey()" buttonTitle="Hinzufügen" src="add" :disabled="ivrData.speachSystemKeys.length === 9" cssClass="btn btn-primary"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footer">
                    <div class="left">
                        <ButtonIconLeft v-if="editMode" class="btn-delete" @onClick="openDeleteModal" buttonTitle="Hotline löschen" src="delete" cssClass="btn btn-tertiary"/>
                    </div>
                    <div class="right">
                        <ButtonNormal @onClick="$router.push('/groups')" class="btn-cancel" buttonTitle="Abbrechen" cssClass="btn btn-secondary"/>
                        <ButtonNormal @onClick="saveHotline" class="btn-save" :buttonTitle="saveButtonTitle" cssClass="btn btn-primary"/>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="isModalForUpdateVisible" @close="closeModalForUpdate"
               @confirm="confirmModalForUpdate" confirmationButtonText="Speichern">
            <template slot="header">
                Möchtest Du die Änderungen wirklich speichern?
            </template>
        </Modal>
        <Modal v-show="isModalForDeleteVisible" :is-red="true" @close="closeModalForDelete"
               @confirm="confirmModalForDelete">
            <template slot="header">
                Möchtest Du die Hotline wirklich löschen?
            </template>
        </Modal>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
@import '../../assets/scss/buttons.scss';
@import '../../assets/scss/general.scss';
@import '../../assets/scss/forms.scss';
@import '../../assets/scss/inputs.scss';
@import '../../assets/scss/grid.scss';

#group-edit {
    .wrapper {
        .description {
            padding-bottom: 32px;
        }
        form {
            .users {
                font-size: 28px;
            }
            .checkbox-wrapper {
                padding-top: 10px;
            }
            .phone-numbers, .voicemailbox-number {
                margin: 50px auto;
                .title {
                    font-weight: bold;
                    margin-bottom: 12px;
                }
            }
            .error-message {
                font-size: 12px;
                font-weight: 600;
                text-align: left;
                color: $red;
            }
            .has-error {
                border-color: #f54d00;
            }
        }
        .speach-system {
            .speach-system-title {
                font-size: 28px;
                letter-spacing: 0;
                line-height: 38px;
                padding-bottom: 24px;
            }
            .section-title {
                font-size: 18px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 24px;
                padding-bottom: 8px;
            }
            .section-description {
                padding-top: 15px;
                font-size: 18px;
                letter-spacing: 0;
                line-height: 24px;
            }
            .speach-system-keys{
                table {
                    grid-row: 2;
                    justify-self: start;
                    text-align: left;
                    border-spacing: 0;
                    padding: 16px 0;
                    width: 100%;
                    font-size: 18px;
                    tr {
                        height: 48px;
                        &:nth-child(odd) {
                            background-color: white;
                        }
                    }
                    th {
                        color: white;
                        font-weight: bold;
                        background-color: $th-background-color;
                        padding: 6px 16px;
                        text-align: left;
                    }
                    td {
                        padding: 6px 16px;
                        .family-name {
                            font-weight: bold;
                        }
                    }
                    .btn-edit {
                        float: right;
                    }
 
                    .custom-select {
                        position: relative;
                        display: block;
                        max-width: 70px;
                        min-width: 70px;
                        border: 1px solid #dbdbdb;
                        background-color: #fff;
                        z-index: 10;
                        border-radius: 2px;
                    }
                    .custom-select select {
                    border: none;
                    outline: none;
                    background: transparent;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    border-radius: 0;
                    margin: 0;
                    display: block;
                        width: 68px;
                        padding: 5px 14px 5px 14px;
                        font-size: 16px;
                    color: #676767;
                    line-height: 19px;
                    }
                    .custom-select:after {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 30px;
                        height: 100%;
                        line-height: 24px;
                        content: "";
                        background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right #f2f2f2;
                        background-position-x: 6px;
                        text-align: center;
                        color: #dbdbdb;
                        font-size: 24px;
                        border-left: 1px solid #dbdbdb;
                        z-index: -1;
                        border-top-right-radius: 2px;
                        border-bottom-right-radius: 2px;
                    }
                    .table-number-input {
                        font-size: 18px;
                    letter-spacing: 0;
                    line-height: 24px;
                        border-radius: 2px;
                        border: 1px solid #dbdbdb;
                        color: #676767;
                        height: 30px;
                        padding: 0 10px 0 10px;
                    }
                    .table-number-input:focus, input:focus, input[type]:focus, .uneditable-input:focus {   
                        border: 1px solid orange;
                        outline: 0 none;
                    }
                }
                .table-footer {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    padding-top: 8px;
                    padding-bottom: 32px;
                    .btn-add {
                        width: 142px;
                        height: 34px;
                    }
                    .btn:disabled {
                        opacity: 1;
                        background: $grey-light;
                        border: $grey-light;
                        color: #fff;
                    }
                }
            }
        }

        .footer {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-bottom: 25px;
            .left {
                display: flex;
            }
            .right {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                .btn-cancel {
                    margin-right: 20px;
                    margin-bottom: 20px;
                }
                .btn-save {
                    height: 48px;
                    width: 240px;
                    border-radius: 2px;
                    border: 2px solid $orange;
                    background-color: $orange;
                    color: white;
                    font-size: 16px;
                }
            }
        }
    }
            .line {
                border: 1px solid $grey-light;
                margin: 0px;
            }
}
</style>
